import React from 'react';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { PlaylistAdd } from '@material-ui/icons';
import { dialogContexts } from '../../constants/constants';

const MenuItemOptionCreate = ({ setOpenDialog, setSelectedOptionId, setDialogContext }) => (
  <>
    <ListItem
      button
      onClick={() => {
        setOpenDialog(true);
        setSelectedOptionId(dialogContexts.CREATE);
        setDialogContext(dialogContexts.CREATE);
      }}
    >
      <ListItemIcon>
        <PlaylistAdd />
      </ListItemIcon>
      <ListItemText
        primary='Add New Option'
        primaryTypographyProps={{ color: 'textSecondary', variant: 'button' }}
      />
    </ListItem>
  </>
);

export default MenuItemOptionCreate;
